import { MakeCall } from '../createMakeCall';
import { FavoriteUnitType } from '../types/inventory/FavoriteUnitType';

export interface FavoriteUnitTypesResource {
  favorites: FavoriteUnitType[];
  count: number;
}

export interface Options {
  /**
   * @description comma-separated string with possible values: `listing`
   */
  expand?: string;
  withPhotos: boolean;
}

const getFavoriteUnitTypes =
  (makeCall: MakeCall) => (userId: number, options?: Options) =>
    makeCall<FavoriteUnitTypesResource>('GET', '/api/v2/unit-types/favorites', {
      query: { userId, ...options },
    });
export { getFavoriteUnitTypes };
